module.exports = __webpack_public_path__ + "static/img/share-qq_light.0c0679dd.png";